import { FC, useCallback, useState } from 'react';

import TextField, { TextFieldProps } from '@mui/material/TextField';

type Props = TextFieldProps & {
  limit: number;
};

export type LimitedTextFieldProps = Props;

const LimitedTextField: FC<Props> = ({ limit, value, onChange, ...props }) => {
  // @ts-expect-error
  const [length, setLength] = useState(value.length);

  const handleChange = useCallback(
    event => {
      if (!onChange) return;

      const current = event.target.value.length;

      if (current <= limit) {
        onChange(event);
        setLength(current);
      }
    },
    [limit, onChange]
  );

  return (
    <TextField
      {...props}
      value={value}
      onChange={handleChange}
      helperText={`${length} / ${limit}`}
    />
  );
};

export default LimitedTextField;
